import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Typography } from "@mui/material";
import { AppAlert } from "./form/alert";
import FlexBox from "./layouts/Flexbox";
import { APP_COLORS } from "../enums";

type BrowserTimezoneAlertProps = {
  text?: string;
};

export function BrowserTimezoneAlert({
  text = "Times are shown in your current browser's time zone",
}: BrowserTimezoneAlertProps) {
  return (
    <AppAlert severity="default" sx={{ backgroundColor: APP_COLORS.greyLight }}>
      <FlexBox alignItems="center" gap={0.5}>
        <AccessTimeOutlinedIcon fontSize="small" />
        <Typography variant="small-ibmPlexMono-medium">{text}</Typography>
      </FlexBox>
    </AppAlert>
  );
}

